module.exports = __webpack_public_path__ + "static/illustrations_preview-99dc8a9fa0b2d598839edc9b2764beb0.svg";